import axios from 'axios'

import { noPaginationParams } from '@/common/constants'

const configurationServices = {
  getBankAccounts: () => axios.get(`${import.meta.env.VITE_HOST}/merchant/payment-methods`),
  getBillingPreferences: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/billing`),
  editBillingPreferences: ({ storeId, preferences }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/billing`, preferences),
  getWidgetPreferences: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/widget`),
  editWidgetPreferences: ({ storeId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/widget`, preferences),
  getStoreLogisticsPreferences: ({ storeId, withDeleted = null, withUsed = null }) =>
    axios.get(`${import.meta.env.VITE_HOST}/preferences/logistics`, {
      params: { with_deleted: withDeleted, with_used: withUsed, store_id: storeId },
    }),
  createBankAccount: params => axios.post(`${import.meta.env.VITE_HOST}/merchant/payment-methods`, { ...params }),
  changeSubscriptionPlan: ({ subscriptionPlan }) =>
    axios.post(`${import.meta.env.VITE_HOST}/merchant/subscription-plan`, { subscription_plan: subscriptionPlan }),
  editDeliveryMethod: ({ storeId, deliveryMethod }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/${deliveryMethod.id}`,
      deliveryMethod
    ),
  partialEditDeliveryMethod: ({ storeId, deliveryMethodId, payload }) =>
    axios.patch(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/${deliveryMethodId}`,
      payload
    ),
  editDeliveryMethods: ({ storeId, deliveryMethods }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/display`,
      deliveryMethods
    ),
  deleteDeliveryMethod: ({ storeId, deliveryMethodId }) =>
    axios.delete(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/${deliveryMethodId}`
    ),
  createDeliveryMethod: ({ storeId, deliveryMethod }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods`, deliveryMethod),
  getUserGroups: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/groups`),
  getMerchantUserGroups: ({ merchantId }) => axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/groups`),
  deleteUserGroup: ({ storeId, groupId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/groups/${groupId}`),
  deleteUser: ({ storeId, userId }) => axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/users/${userId}`),
  resetUserPassword: ({ storeId, userId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/users/${userId}/reset-password`),
  migrateUserGroup: ({ storeId, groupId, newGroupId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/groups/${groupId}/migrate-users`, { group: newGroupId }),
  getUsers: ({ storeId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/users`, {
      params: { ...params, ...noPaginationParams },
    }),
  getUserGroup: ({ storeId, groupId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/groups/${groupId}`),
  createUserGroup: ({ storeId, group }) => axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/groups`, group),
  editUserGroup: ({ storeId, group }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/groups/${group.id}`, group),
  getPermissions: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/permissions`),
  getUser: ({ storeId, userId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/users/${userId}`),
  createUser: ({ storeId, user }) => axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/users`, user),
  editUser: ({ storeId, userId, user }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/users/${userId}`, user),
  getAllowList: ({ storeId, page, pageSize, status, search }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/allow-list`, {
      params: { page, page_size: pageSize, status, search },
    }),
  deleteException: ({ storeId, exceptionId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/allow-list/${exceptionId}`),
  toggleException: ({ storeId, exceptionId, value }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/allow-list/${exceptionId}/${value}`),
  createException: ({ storeId, exception }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/allow-list`, exception),
  editException: ({ storeId, exception }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/allow-list/${exception.id}`, exception),
  changeStoreInfo: ({ storeId, params }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}`, { ...params }),
  getStoreProductTypes: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/product-types`, { params: { store_id: storeId } }),
  getLocations: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/locations`),
  createLocation: ({ storeId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/locations`, payload),
  editLocation: ({ storeId, locationId, payload }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/locations/${locationId}`, payload),
  deleteLocation: ({ storeId, locationId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/locations/${locationId}`),
  createDefaultDeliveryMethods: ({ storeId, locationId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/locations/${locationId}/default-delivery-methods`),
  getReturnInstructionSets: ({ storeId, type, search, page, pageSize, pagination }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/return-instruction-sets`, {
      params: { type, search, page, page_size: pageSize, pagination },
    }),
  getReturnInstructionSet: ({ storeId, returnInstructionSetId }) =>
    axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/return-instruction-sets/${returnInstructionSetId}`
    ),
  deleteReturnInstructionSet: ({ storeId, returnInstructionSetId, replacementId }) =>
    axios.delete(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/return-instruction-sets/${returnInstructionSetId}`,
      { data: replacementId ? { replacement_id: replacementId } : undefined }
    ),
  createReturnInstructionSet: ({ storeId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/return-instruction-sets`, payload),
  editReturnInstructionSet: ({ storeId, returnInstructionSetId, payload }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/return-instruction-sets/${returnInstructionSetId}`,
      payload
    ),
  reorderReturnInstructionSets: ({ storeId, payload }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/return-instruction-sets/display`,
      payload
    ),
  installStripeAccount: ({ storeId, integrationId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/integrations/${integrationId}/install`),
  getShippingMethods: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods`),
  editShippingMethods: ({ storeId, shippingMethods }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/display`,
      shippingMethods
    ),
  deleteShippingMethod: ({ storeId, shippingMethodId }) =>
    axios.delete(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/${shippingMethodId}`
    ),
  editShippingMethod: ({ storeId, shippingMethod }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/${shippingMethod.id}`,
      shippingMethod
    ),
  partialEditShippingMethod: ({ storeId, shippingMethodId, payload }) =>
    axios.patch(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/${shippingMethodId}`,
      payload
    ),
  createShippingMethod: ({ storeId, shippingMethod }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods`, shippingMethod),
  getIntegrations: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/integrations`),
  createIntegration: ({ storeId, integration }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/integrations`, integration),
  editIntegration: ({ storeId, integration }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/integrations/${integration.id}`, integration),
  toggleIntegration: ({ storeId, integrationId, value }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/integrations/${integrationId}/${value}`),
  uninstallIntegration: ({ storeId, integrationId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/integrations/${integrationId}/uninstall`),
  getShipmentsConfiguration: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/shipments`),
  editShipmentsConfiguration: ({ storeId, payload }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/shipments`, payload),
  getMerchantPreferences: ({ merchantId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/features`),
  editMerchantPreferences: ({ merchantId, payload }) =>
    axios.put(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/features`, { ...payload }),
  getMerchantRefundMethods: ({ merchantId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/refund-methods`),
  editMerchantRefundMethodsConfiguration: ({ merchantId, configuration }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/refund-methods/configuration`,
      configuration
    ),
  getMerchantTheme: ({ merchantId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/theme`),
  modifyMerchantTheme: ({ merchantId, theme }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/theme`, theme),
  getPortalSettingsType: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/settings`),
  editPortalSettingsType: ({ returnPortalId, params }) =>
    axios.put(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/settings`, params),
  getMerchantCommunicationsPreferences: ({ merchantId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/communications`),
  editMerchantCommunicationsPreferences: ({ merchantId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/communications`, preferences),
  getMerchantEmailTemplates: ({ merchantId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates`, {
      params: { ...noPaginationParams },
    }),
  createMerchantEmailTemplate: ({ merchantId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates`, payload),
  toggleMerchantEmailTemplate: ({ merchantId, templateId, status }) =>
    axios.post(
      `${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/${templateId}/${status}`
    ),
  deleteMerchantEmailTemplate: ({ merchantId, templateId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/${templateId}`),
  duplicateMerchantEmailTemplate: ({ merchantId, templateId }) =>
    axios.post(
      `${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/${templateId}/duplicate`
    ),
  getMerchantDetailEmailTemplate: ({ merchantId, templateId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/${templateId}`),
  editMerchantDetailEmailTemplate: ({ merchantId, templateId, payload }) =>
    axios.put(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/${templateId}`, payload),
  getMerchantPreviewEmailTemplate: ({ merchantId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/preview`, payload),
  getShippingWidgetPreferences: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipping-widget`),
  editShippingWidgetPreferences: ({ storeId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipping-widget`, preferences),
  getSizingWidgetPreferences: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/recommendation-widget`),
  editSizingWidgetPreferences: ({ storeId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/recommendation-widget`, preferences),
  getBracketingWidgetPreferences: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/bracketing-widget`),
  editBracketingWidgetPreferences: ({ storeId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/bracketing-widget`, preferences),
  getTryOnWidgetPreferences: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/tryon-widget`),
  editTryOnWidgetPreferences: ({ storeId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/tryon-widget`, preferences),
  getTryOnWidgetPreview: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/tryon-widget/preview`),
  gorgiasIntegration: ({ storeId, integrationId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/integrations/${integrationId}/install`),
  editMerchantEmailTemplatesDisplay: ({ merchantId, emailTemplates }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/display`,
      emailTemplates
    ),
  uploadMerchantEmailTemplateImage: ({ merchantId, formData }) =>
    axios.post(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-templates/images`, formData),
  getMerchantEmailTheme: ({ merchantId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-theme`),
  editMerchantEmailTheme: ({ merchantId, payload }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-theme`, payload),
  getMerchantEmailThemePreview: ({ merchantId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/preferences/email-theme/preview`, payload),
  getPolicyRules: ({ storeId, search, page, pageSize, active, pagination, state, withDeleted }) =>
    axios.get(`${import.meta.env.VITE_HOST}/policy-rules`, {
      params: {
        store_id: storeId,
        search,
        page,
        page_size: pageSize,
        active,
        pagination,
        state,
        with_deleted: withDeleted,
      },
    }),
  getPolicyRule: ({ storeId, ruleId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/policy-rules/${ruleId}`),
  deletePolicyRule: ({ storeId, ruleId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/policy-rules/${ruleId}`),
  reorderPolicyRules: ({ storeId, rules }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/policy-rules/display`, rules),
  createPolicyRule: ({ storeId, policyRule }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/policy-rules`, policyRule),
  editPolicyRule: ({ storeId, policyRule }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/policy-rules/${policyRule.id}`, policyRule),
  getAvailabilityCriteria: ({ storeId, search, page, pageSize }) =>
    axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/availability-criterion`,
      {
        params: { search, page, page_size: pageSize },
      }
    ),
  getAvailabilityCriterion: ({ storeId, criterionId }) =>
    axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/availability-criterion/${criterionId}`
    ),
  createAvailabilityCriterion: ({ storeId, criterion }) =>
    axios.post(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/availability-criterion`,
      criterion
    ),
  editAvailabilityCriterion: ({ storeId, criterionId, criterion }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/availability-criterion/${criterionId}`,
      criterion
    ),
  deleteAvailabilityCriterion: ({ storeId, criterionId }) =>
    axios.delete(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/availability-criterion/${criterionId}`
    ),
  reorderAvailabilityCriteria: ({ storeId, criteria }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/delivery-methods/availability-criterion/display`,
      criteria
    ),
  getShippingAvailabilityCriteria: ({ storeId, search, page, pageSize }) =>
    axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/availability-criterion`,
      {
        params: { search, page, page_size: pageSize },
      }
    ),
  deleteShippingAvailabilityCriterion: ({ storeId, criterionId }) =>
    axios.delete(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/availability-criterion/${criterionId}`
    ),
  reorderShippingAvailabilityCriteria: ({ storeId, criteria }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/availability-criterion/display`,
      criteria
    ),
  getShippingAvailabilityCriterion: ({ storeId, criterionId }) =>
    axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/availability-criterion/${criterionId}`
    ),
  createShippingAvailabilityCriterion: ({ storeId, criterion }) =>
    axios.post(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/availability-criterion`,
      criterion
    ),
  editShippingAvailabilityCriterion: ({ storeId, criterionId, criterion }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/logistics/shipping-methods/availability-criterion/${criterionId}`,
      criterion
    ),
  getTopBannerWidgetPreferences: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/top-banner-widget`),
  editTopBannerWidgetPreferences: ({ storeId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/top-banner-widget`, preferences),
  getPackaging: ({ storeId, page, search, pageSize }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/packaging`, {
      params: { page, search, page_size: pageSize },
    }),
  getPackagingDetail: ({ storeId, packagingId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/packaging/${packagingId}`),
  createPackaging: ({ storeId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/packaging`, payload),
  editPackaging: ({ storeId, packagingId, payload }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/packaging/${packagingId}`, payload),
  deletePackaging: ({ storeId, packagingId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/packaging/${packagingId}`),
  editPackagingDisplay: ({ storeId, packaging }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/packaging/display`, packaging),
  setDefaultPackaging: ({ storeId, packagingId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/packaging/${packagingId}/set-default`),
  getHsCodes: ({ query }) => axios.get(`${import.meta.env.VITE_HOST}/inventory/hs-codes`, { params: { q: query } }),
  getHtsCodes: ({ query }) => axios.get(`${import.meta.env.VITE_HOST}/inventory/hts-codes`, { params: { q: query } }),
  getPortalPreferences: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/features`),
  editPortalPreferences: ({ returnPortalId, payload }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/features`, { ...payload }),
  getPortalRefundMethods: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/refund-methods`),
  editPortalRefundMethodsConfiguration: ({ returnPortalId, configuration }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/refund-methods/configuration`,
      configuration
    ),
  getPortalTheme: ({ returnPortalId }) => axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/theme`),
  modifyPortalTheme: ({ returnPortalId, theme }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/theme`, theme),
  getPortalCommunicationsPreferences: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/communications`),
  editPortalCommunicationsPreferences: ({ returnPortalId, preferences }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/communications`, preferences),
  getPortalEmailTemplates: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates`, {
      params: { ...noPaginationParams },
    }),
  createPortalEmailTemplate: ({ returnPortalId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates`, payload),
  togglePortalEmailTemplate: ({ returnPortalId, templateId, status }) =>
    axios.post(
      `${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates/${templateId}/${status}`
    ),
  deletePortalEmailTemplate: ({ returnPortalId, templateId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates/${templateId}`),
  duplicatePortalEmailTemplate: ({ returnPortalId, templateId }) =>
    axios.post(
      `${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates/${templateId}/duplicate`
    ),
  getPortalDetailEmailTemplate: ({ returnPortalId, templateId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates/${templateId}`),
  editPortalDetailEmailTemplate: ({ returnPortalId, templateId, payload }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates/${templateId}`,
      payload
    ),
  getPortalPreviewEmailTemplate: ({ returnPortalId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates/preview`, payload),
  editPortalEmailTemplatesDisplay: ({ returnPortalId, emailTemplates }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-templates/display`,
      emailTemplates
    ),
  getPortalEmailTheme: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-theme`),
  editPortalEmailTheme: ({ returnPortalId, payload }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-theme`, payload),
  getPortalEmailThemePreview: ({ returnPortalId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/email-theme/preview`, payload),
  getPortalReturnReasons: ({ returnPortalId, withDeleted = null, disabled = null }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/return-reasons`, {
      params: { with_deleted: withDeleted, disabled },
    }),
  editPortalReturnReason: ({ returnPortalId, returnReason }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/return-reasons/${returnReason.id}`,
      returnReason
    ),
  editPortalReturnReasons: ({ returnPortalId, returnReasons }) =>
    axios.put(
      `${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/return-reasons/display`,
      returnReasons
    ),
  deletePortalReturnReason: ({ returnPortalId, returnReasonId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/return-reasons/${returnReasonId}`),
  createPortalReturnReason: ({ returnPortalId, returnReason }) =>
    axios.post(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/return-reasons`, returnReason),
  getPortalCustomCopies: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/custom-messages`),
  modifyPortalCustomCopies: ({ returnPortalId, copies }) =>
    axios.post(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/preferences/custom-messages`, copies),
  getOrderTrackingPreview: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/preview`),
  getOrderTrackingPreviewOrders: ({ storeId, search }, config) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/preview/orders`, {
      params: { search },
      signal: config?.signal,
    })
  },
  getOrderTrackingPreviewOrder: ({ storeId, orderId }, config) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/preview/orders/${orderId}`, {
      signal: config?.signal,
    })
  },
  getOrderTrackingPreviewRecommendedProducts: ({ storeId, params }, config) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/preview/recommended-products`, {
      params,
      signal: config?.signal,
    })
  },
  getOrderTrackingPreviewOrderRecommendedProducts: ({ storeId, orderId, params }, config) => {
    return axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/preview/orders/${orderId}/recommended-products`,
      { params, signal: config?.signal }
    )
  },
  editOrderTrackingLayout: ({ storeId, layout }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/layout`, layout),
  getOrderTrackingEmbed: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/embed`),
  editOrderTrackingEmbed: ({ storeId, embed }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/embed`, embed),
  getVisibilityCriteria: ({ storeId, search, page, pageSize, pagination }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/visibility-criteria`, {
      params: { search, page, page_size: pageSize, pagination },
    })
  },
  getVisibilityCriterion: ({ storeId, criterionId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/visibility-criteria/${criterionId}`)
  },
  createVisibilityCriterion: ({ storeId, criterion }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/visibility-criteria`, criterion)
  },
  editVisibilityCriterion: ({ storeId, criterionId, criterion }) => {
    return axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/visibility-criteria/${criterionId}`,
      criterion
    )
  },
  deleteVisibilityCriterion: ({ storeId, criterionId }) => {
    return axios.delete(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/visibility-criteria/${criterionId}`
    )
  },
  reorderVisibilityCriteria: ({ storeId, criteria }) => {
    return axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/visibility-criteria/display`,
      criteria
    )
  },
  getAdvancedBlocks: ({ storeId, pagination }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/advanced-blocks`, {
      params: { pagination },
    })
  },
  editAdvancedBlock: ({ storeId, blockUid, config }) => {
    return axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/advanced-blocks/${blockUid}`,
      config
    )
  },
  deleteAdvancedBlock: ({ storeId, blockUid }) => {
    return axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/advanced-blocks/${blockUid}`)
  },
  uploadOrderTrackingImage: ({ storeId, formData }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/order-tracking/images`, formData)
  },
  requestSmartTracking: () => {
    return axios.post(`${import.meta.env.VITE_HOST}/merchant/smart-tracking/request`)
  },
  getReturnProtectionAppearance: ({ storeId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/return-protection`)
  },
  editReturnProtectionAppearance: ({ storeId, appearance }) => {
    return axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/return-protection`, appearance)
  },
  getReturnProtectionProduct: ({ storeId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/return-protection/product`)
  },
  editReturnProtectionProduct: ({ storeId, product }) => {
    return axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/return-protection/product`, product)
  },
}

export default configurationServices
